import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
import { client } from "./service.js";

export async function getDashboardCourt(placeId) {
    try {
        let response = await client.get(`${adminUrl}/dashboard/courts?placeId=${placeId}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getTodayBooking({ date }) {
    try {
        let response = await client.get(`${adminUrl}/dashboard/booking?date=${date}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getRentListBooking({ date }) {
    try {
        let response = await client.get(`${adminUrl}/dashboard/rent?date=${date}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getBuyListBooking({ date }) {
    try {
        let response = await client.get(`${adminUrl}/dashboard/sell?date=${date}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getVerificationList({ date }) {
    try {
        let response = await client.get(`${adminUrl}/dashboard/verification`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function updateVerificationStatus({ _id, reject, verify, name, gender }) {
    try {
        let response = await client.post(`${adminUrl}/dashboard/verification/update/${_id}`, {
            reject, verify, name, gender
        })
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data }
    }
}

export async function demoteVerificationStatus({ _id, reject, verify }) {
    try {
        let response = await client.post(`${adminUrl}/dashboard/verification/demote/${_id}`, {
            reject, verify
        })
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data }
    }
}

export async function updateVerificationPhoto({ _id, idPhoto }) {
    try {
        let response = await client.post(`${adminUrl}/dashboard/verification/update-photo/${_id}`, {
            idPhoto
        })
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data }
    }
}

export async function revertVerification({ _id }) {
    try {
        let response = await client.get(`${adminUrl}/player/revert-verification/${_id}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data }
    }
}

export async function getWeather({ date }) {
    try {
        let response = await client.get(`${adminUrl}/weather?date=${date}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data }
    }
}

export async function setWeather({ weather }) {
    try {
        let response = await client.post(`${adminUrl}/weather-set`, {
            weather
        })
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data }
    }
}

export async function getAvailableBallBoy() {
    try {
        let response = await client.get(`${adminUrl}/add-ons/available-ballboys`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data }
    }
}

export async function getSummaryPayment({ date }) {
    try {
        let response = await client.get(`${adminUrl}/dashboard/payment-summary?date=${date}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return { error: e.response.data }
    }
}